var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.984,
    height: 18.519,
    viewBox: "0 0 15.984 18.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-upload",
    d: "M50.7,11.633,48.676,8.748V3.668A.931.931,0,0,0,48.4,3L45.652.275A.946.946,0,0,0,44.982,0H36.717A1.61,1.61,0,0,0,35.1,1.6V16.056a1.61,1.61,0,0,0,1.614,1.6h7.561a2.148,2.148,0,0,0,.237.272,2.118,2.118,0,0,0,1.463.588h1.305a2.121,2.121,0,0,0,1.463-.588,2.085,2.085,0,0,0,.659-1.52V14.9a2.111,2.111,0,0,0,1.44-1.087A2.087,2.087,0,0,0,50.7,11.633ZM40.231,15.649H37.091V2.011h6.674V3.774a1.145,1.145,0,0,0,1.148,1.139h1.776v2.5h-.01A2.105,2.105,0,0,0,44.9,8.3l-2.34,3.33a2.087,2.087,0,0,0-.141,2.18,2.111,2.111,0,0,0,1.44,1.087v.748H40.231Zm9.126-2.606a.443.443,0,0,1-.393.237H47.726v3.133a.442.442,0,0,1-.443.44H45.977a.442.442,0,0,1-.443-.44V13.279H44.3a.443.443,0,0,1-.393-.237.436.436,0,0,1,.03-.455l2.333-3.322a.445.445,0,0,1,.364-.188h0a.445.445,0,0,1,.363.188l2.334,3.322A.436.436,0,0,1,49.357,13.042Z",
    transform: "translate(-35.103)",
    fill: "#0000b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.3fe6cb805aa6c3ab6cdd20425ff63237.svg";
export { ForwardRef as ReactComponent };